/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';

export interface GetList_4$Params {
}

export function getList_4(http: HttpClient, rootUrl: string, params?: GetList_4$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserAlertNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, getList_4.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserAlertNotificationSetting>>;
    })
  );
}

getList_4.PATH = '/api/user/notification/alert/setting';
